import {
  SET_DISP,
  SET_ROUTE,
  SET_DATE,
  SET_NEW_DATE_DISP,
  SET_NEW_ROUTE_DISP,
  SET_FETCH_STATE,
  SET_SERVICE_STATE,
  SET_LANGUAGE
} from "../actions";

export const ruta = (state, action) => {

  switch (action.type) {
    case SET_ROUTE:
      return {...state, idRuta: action.value}
    case SET_DISP:
      return {...state, dataDisp: action.value}
    case SET_DATE:
      return {...state, mes: action.value}
    case SET_NEW_DATE_DISP:
      return {...state, mes: action.value.mes, dataDisp: action.value.dataDisp}
    case SET_NEW_ROUTE_DISP:
      return {...state, idRuta: action.value.idRuta, dataDisp: action.value.dataDisp}
    case SET_FETCH_STATE:
      return {...state, fetchingState: action.value.fetchingState}
    case SET_SERVICE_STATE:
      return {...state, serviceState: action.value}
    case SET_LANGUAGE:
      return {...state, language: action.value}
    default:
      return state;
  }

};
